export default function isInternetExplorer(ua: string) {
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); // IE 11
  return msie > 0 || trident > 0;
}
